module.exports = __webpack_public_path__ + "static/img/dl_yijiandl.2198ed60.png";